module.exports = __webpack_public_path__ + "static/media/invoiced.abe177ca.svg";